<script setup>
import {reactive,onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const data = reactive({
  openForm: false,
  claimLimit: '',
  currentClaims: 0,
  loading: false,
  loaded: true,
});

const getData = () => {
  data.loading = true
  ApiWrapper.post('claim-limiter', 'claim-limiter', {
        userid: props.contextIdA,
      })
      .then((response) => {
        data.loading = false
        if(response.limit == null){
          data.claimLimit = 'NA'
        }else{
          data.claimLimit = response.limit
        }
        if(response.currentClaims){
          data.currentClaims = response.currentClaims
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.loading = false
      })
}

const updateLimit = () => {
  data.loading = true

  ApiWrapper.post('claim-limiter', 'update-limit', {
        userid: props.contextIdA,
        limit: data.claimLimit
      })
      .then((response) => {
        data.loading = false
        data.openForm = false
        ToastUtil.successMsg('Updated claim limits for this person');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

onMounted(()=>{
  getData()
})

</script>

<template>
  <v-container fluid v-if="data.loaded===true">
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>Claim Limit</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn v-if="!data.openForm" size="small" color="primary" @click="Permissions.checkPermissions(['claims.update-limits']) ? data.openForm = true : true">
          Update
        </v-btn>
      </v-toolbar>

      <v-row justify="center">
        <v-col
            cols="12"
            sm="6"
        >
          <v-hover
              v-slot="{ hover }"
          >
            <v-card
                :elevation="hover ? 4 : 1"
                :class="{ 'on-hover': hover }"
                class="mx-auto mb-4"
                height="250"
                max-width="250"
            >
              <div v-if="data.openForm === false" @click="Permissions.checkPermissions(['claims.update-limits']) ? data.openForm = true : true" style="cursor:pointer">
                <v-row align="center" justify="center">
                  <v-col>
                    <v-card-text>
                      <v-row >
                        <v-col class="display-2 text-center">
                          {{data.currentClaims}}/{{data.claimLimit}}
                        </v-col>
                      </v-row>
                      <v-row align="center" justify="center">
                        <v-col class="subtitle-1 text-center">
                          Number of
                          <br>
                          Assigned Claims
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-col>
                </v-row>
              </div>
              <!-- onSubmit="return false" prevents form from submitting when pressing enter-->
              <div v-if="data.openForm">
                <v-form onSubmit="return false">
                  <v-row align="center" justify="center">
                    <v-col cols="6" class="pb-0">
                      <v-card-subtitle class="pa-0">
                        Update Limit
                      </v-card-subtitle>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-col cols="6" class="pb-0">
                      <v-text-field
                          v-model="data.claimLimit"
                          filled
                          type="number"
                          @click="Permissions.checkPermissions(['claims.update-limits']) ? data.openForm = true : true"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0">
                      <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn
                              class="error"
                              @click="getData(); data.openForm = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                              class="primary"
                              @click="updateLimit()"
                          >
                            Save
                          </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}

.v-card.on-hover.theme--dark {
  background-color: rgba(255, 255, 255, 0.8)
}

.v-card-text {
  color: #000
}
</style>